"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setOpen = exports.get = void 0;
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var spritesUi_1 = require("@dive/spriteRecyclers/spritesUi");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var diveMessage_mouseInput_1 = require("@voyage/multi/diveMessage_mouseInput");
var diveMessage_mouseInput_sidecar_1 = require("@voyage/multi/diveMessage_mouseInput-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var diveUi_mouseUtils_1 = require("./diveUi_mouseUtils");
var diveUi_mouseUtils_sidecar_1 = require("./diveUi_mouseUtils-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(true);
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var obj = {
        isOpen: true,
        selectedIdx: 0,
    };
    return obj;
};
var setOpen = function (isOpen) {
    var obj = get();
    obj.isOpen = isOpen;
};
exports.setOpen = setOpen;
var update = function () {
    var obj = get();
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    var sx = gb.width / 2 - 200 - 100;
    var sy = 50;
    var x = sx;
    var y = sy;
    // Get our selected character
    var selectedCrew = voyagePicker_sidecar_1.voyagePicker.get().selectedCrew;
    // Idle frame
    var bounceIdx = diveSimulationManager_sidecar_1.diveSimulationManager.get2frameIdx();
    var text = '';
    // Get all of our crew
    var heroes = diveCrew_sidecar_1.diveCrew.getAllFiltered(function (c) { return c.type === diveCrew_1.EVoyageCrewType.Hero; });
    for (var i = 0; i < heroes.length; i++) {
        var hero = heroes[i];
        var isDead = false;
        var imgBox = spritesUi_1.spritesUi.getNext(x, y, sprites_sidecar_1.sprites.diveEffectsBoxAbility[0]);
        var isSelected = selectedCrew === hero;
        if (isSelected) {
            spritesUi_1.spritesUi.changeImageFrame(imgBox, sprites_sidecar_1.sprites.diveEffectsBoxAbilityCurrent[0]);
            if (!text) {
                text = hero.name;
            }
        }
        var d = hero.heroState;
        assert_sidecar_1.assert.notNil(d);
        var frames_1 = d.data.frames;
        var frame = frames_1.idle[bounceIdx % frames_1.idle.length];
        // Dead!
        if (hero.hitpoints <= 0) {
            frame = frames_1.dead[0];
            isDead = true;
        }
        var imgHero = spritesUi_1.spritesUi.getNext(x, y, frame);
        var hit = diveUi_mouseUtils_sidecar_1.diveUi_mouseUtils.hitTest(imgBox);
        if (hit === diveUi_mouseUtils_1.EHitTest.LeftFirstDown) {
            // Select our next hero
            diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput.sendMessageToAll({
                frame: 0,
                hint: diveMessage_mouseInput_1.EDiveInputHint.SelectCrew,
                tx: (hero === null || hero === void 0 ? void 0 : hero.lerp_target_x) || 0,
                ty: (hero === null || hero === void 0 ? void 0 : hero.lerp_target_y) || 0,
                targetId: (hero === null || hero === void 0 ? void 0 : hero.id) || 0,
                fromMultiId: voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId(),
                centerOn: true,
            });
        }
        if (!isSelected) {
            if (hit === diveUi_mouseUtils_1.EHitTest.Over ||
                hit === diveUi_mouseUtils_1.EHitTest.LeftHeldDown ||
                hit === diveUi_mouseUtils_1.EHitTest.LeftFirstDown) {
                spritesUi_1.spritesUi.changeImageFrame(imgBox, sprites_sidecar_1.sprites.diveEffectsBoxAbilityHover[0]);
                text = hero.name;
            }
        }
        x += 50;
    }
    if (!text) {
        text = 'Heroes';
    }
    x = sx;
    y = sy;
    diveFont_sidecar_1.diveFont.writeAbsolute(x - 20, y - 40, text, 0.5);
};
exports.update = update;
//       diveMessage_mouseInput.sendMessageToAll({
//         hint: hint,
//         frame: 0,
//         centerOn: false,
//         targetId: targetId,
//         fromMultiId: voyageWebsockets.getMultiId(),
//         tx: 0,
//         ty: 0,
//       })
//     }
//     if (hit === EHitTest.LeftFirstDown) {
//       obj.selectedIdx = i
//       // Clicked ability
//       sendHint(c.inputHint)
//     }
//     if (hit === EHitTest.RightFirstDown && c.inputHintAlt) {
//       // obj.selectedIdx = i
//       // Right-clicked ability (alt)
//       sendHint(c.inputHintAlt)
//     }
//     if (!isSelected) {
//       if (
//         hit === EHitTest.Over ||
//         hit === EHitTest.LeftHeldDown ||
//         hit === EHitTest.LeftFirstDown
//       ) {
//         spritesUi.changeImageFrame(img, sprites.diveEffectsBoxAbilityHover[0])
//       }
//     }
//     if (c.frame.length > 0) {
//       spritesUi.getNext(x, y, c.frame[0])
//     }
//     if (c.render) {
//       c.render(x, y)
//     }
//     if (c.displayText) {
//       diveFont.writeAbsolute(x - 20, y - 30, c.displayText, 0.5)
//     }
//     if (c.displayNum) {
//       diveFont.writeAbsolute(x - 20, y + 32, '' + c.displayNum, 0.5)
//     }
//     x += 50
//   }
// }
//
